export  const getIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data: {ip: string} = await response.json();
    return data.ip;
  } catch (e: unknown) {
    if (typeof e === "string") {
      console.debug(e)
    } else if (e instanceof Error) {
      console.debug(e.message)
    }
    return "0.0.0.0"
  }
}